  export const setFollowupProgramData = (value) => {
    return {
      type: "SET_FOLLOWUP_PROGRAM_DATA",
      payload: { data: value },
    };
  };
  export const setFollowupProgramCount = (value) => {
    return {
      type: "SET_FOLLOWUP_PROGRAM_COUNT",
      payload: { data: value },
    };
  };
  export const setFollowupProgramsData = (value) => {
    return {
      type: "SET_FOLLOWUP_PROGRAMS_DATA",
      payload: { data: value },
    };
  };